import React from 'react'
import { classify } from 'sidecar-utilities'

import {
  ContainerAlignment,
  ButtonContainerProps,
} from './ButtonContainer.types'

export const ButtonContainer = ({
  align = ContainerAlignment.LEFT,
  className,
  children,
  wrap = true,
}: ButtonContainerProps) => {
  const alignments = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end',
    justified: 'justify-between',
  }

  const containerStyles = {
    alignment: alignments[align],
    layout: 'flex',
    flexWrap: wrap && 'flex-wrap',
    spacing: 'gap-4 mb-4 last:mb-0',
    childrenSpacing: '[&_button]:mb-0 [&_a]:mb-0 [&_span]:mb-0 items-center',
  }

  return (
    <div className={`${classify(containerStyles)} ${className}`}>
      {children}
    </div>
  )
}
